import { Box, Text } from '@chakra-ui/react';
import { IconDownload } from '@tabler/icons';
import { ButtonComponent } from 'components/buttons/ButtonComponent';
import GenericModal from 'components/modal/genericModal/GenericModal';

import { asyncExportMessages } from './variables/asyncExportMessages';

interface ExportOngoingModalProps {
	isOpen: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

export const ExportOngoingModal = ({
	isOpen,
	onConfirm,
	onCancel,
}: ExportOngoingModalProps) => {
	return (
		<GenericModal
			isOpen={isOpen}
			onClose={onCancel}
			onCancel={onCancel}
			onSave={onConfirm}
			title={asyncExportMessages.ONGOING_MODAL.title}
			titleIcon={IconDownload}
			titleIconColor='easyRED.300'
			saveButtonText={asyncExportMessages.ONGOING_MODAL.confirmButton}
			cancelButtonText={asyncExportMessages.ONGOING_MODAL.cancelButton}
			maxWidth='650px'
			zIndex={2000}
			customCancelButton={
				<ButtonComponent
					data-test='cancel-button-modal'
					title={asyncExportMessages.ONGOING_MODAL.cancelButton}
					type='primary'
					onClick={onCancel}
				/>
			}
			customSaveButton={
				<ButtonComponent
					data-test='save-button-modal'
					title={asyncExportMessages.ONGOING_MODAL.confirmButton}
					type='ghost'
					onClick={onConfirm}
				/>
			}
		>
			<Box
				mt={-6}
				mb={6}
			>
				<Text
					color='gray.500'
					fontSize='md'
					fontWeight={200}
				>
					{asyncExportMessages.ONGOING_MODAL.description}
				</Text>
				<Text
					color='gray.500'
					fontSize='md'
					fontWeight={200}
				>
					{asyncExportMessages.ONGOING_MODAL.description2}
				</Text>
			</Box>
		</GenericModal>
	);
};
